<template>
  <v-app >
    <v-app-bar
      app
      color="white"
      dark
      height="100"
    >
    <v-row wrap>
      <v-col cols="4"></v-col>
      <v-col cols="4" class="justify-center">       
         <v-img
         style="margin:auto"
          class="shrink"
          contain
          :src="logo"
          transition="scale-transition"
          width="140"
        /></v-col>
      <v-col cols="4" class="align-center d-flex justify-end pr-6">      
      <v-icon size="25" color="black" class="mx-4" @click="fOpenInsta()">mdi-instagram</v-icon>
      <v-icon size="25" color="black" @click="cartStatus = !cartStatus">mdi-cart</v-icon>     
        </v-col>
    </v-row>
    
    </v-app-bar>

    <v-main>
      <Catalog></Catalog>
    </v-main>

    <v-dialog width="600" v-model="cartStatus">
        <v-card>
          <v-card-title>Tu Compra <v-spacer></v-spacer><v-icon @click="cartStatus=false">mdi-close</v-icon></v-card-title>
          <v-card-text>

            <Cart v-if="cartStatus"></Cart>
          </v-card-text>
          <v-card-actions class="align-right"><v-spacer></v-spacer><v-btn color="#7ACBD6" @click="fCompletarPedido()">Comprar Todo</v-btn> <v-btn @click="fVaciarCarrito">Vaciar carrito</v-btn></v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog width="600" v-model="completed">
        <v-card>
          <v-card-title>Tu Compra <v-spacer></v-spacer><v-icon @click="completed=false">mdi-close</v-icon></v-card-title>
          <v-card-text>
           <h1 color="green">Ha sido completada correctamente</h1>
          </v-card-text>
        </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Catalog from './components/Catalog.vue';
import Cart from './components/Cart.vue'
import Logo from './assets/logo.png'

export default {
  name: 'App',

  components: {
    Catalog,
    Cart
  },

  data: () => ({
    logo: Logo,
    cartStatus: false,
    completed:false
  }),
  methods:{
    fCompletarPedido(){
      this.completed=true
      this.fVaciarCarrito()
    },
    fVaciarCarrito(){
      this.cartStatus = false
      window.localStorage.removeItem('cart')
    },
    fOpenInsta(){
      window.open('http://www.instagram.com/makethedifference_mtd')
    }
  }
  

};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans&display=swap');
  p,h2, .title{
    font-family: 'Josefin Sans', sans-serif !important;
    line-height: 1
  }
  h2{
    font-size: 40px;
    margin-bottom: 30px;
    color:#7ACBD6
  }
 main{
   background-color: #92CBED;
 }
</style>
